import {Map, List, fromJS} from 'immutable';
import axios from "axios";
import { toast } from "react-toastify";

export const types = {
    INIT: 'MODULE/INIT',
    FETCH_MODULES: 'MODULE/FETCH_MODULES',
    FETCH_MODULES_SUCCESS: 'MODULE/FETCH_MODULES_SUCCESS',
    FETCH_STORES: 'MODULE/FETCH_STORES',
    FETCH_STORES_SUCCESS: 'MODULE/FETCH_STORES_SUCCESS',
    FETCH_MODULE_ITEMS: 'MODULE/FETCH_MODULE_ITEMS',
    FETCH_MODULE_ITEMS_SUCCESS: 'MODULE/FETCH_MODULE_ITEMS_SUCCESS',
    FETCH_MODULE_STORES_SUCCESS: 'MODULE/FETCH_MODULE_STORES_SUCCESS',
    SELECT_MODULE: 'MODULE/SELECT_MODULE',
    SHOW_MODULES_ARTICLES: 'MODULE/SHOW_MODULES_ARTICLES',
    SHOW_MODULES_STORES: 'MODULE/SHOW_MODULES_STORES',
    UPDATE_MODULE_QUERY: 'MODULE/UPDATE_MODULE_QUERY',
    UPDATE_MODULE_ITEM_QUERY: 'MODULE/UPDATE_MODULE_ITEM_QUERY',
    UPDATE_ACTIVE_ITEM_FILTER: 'MODULE/UPDATE_ACTIVE_ITEM_FILTER',
    UPDATE_ITEM_STOCK_STATUS_FILTER: 'MODULE/UPDATE_ITEM_STOCK_STATUS_FILTER'
};

export const initialState = fromJS({
    selectedModule: null,
    showArticles: false,
    showStores: false,
    modules: [],
    stores: [],
    moduleItems: [],
    associatedStores: [],
    moduleQuery: '',
    moduleItemQuery: '',
    filters: {
        active: '',
        stockStatus: ''
    },
});

export default (state = initialState, action) => {
    switch (action.type) {
        case types.INIT:
            return state;
        case types.FETCH_MODULES_SUCCESS:
            return state.set('modules', fromJS(action.modules));
        case types.FETCH_STORES_SUCCESS:
            return state.set('stores', fromJS(action.stores));
        case types.FETCH_MODULE_ITEMS_SUCCESS:
            return state.set('moduleItems', fromJS(action.moduleItems));
        case types.FETCH_MODULE_STORES_SUCCESS:
            return state.set('associatedStores', fromJS(action.stores));
        case types.UPDATE_MODULE_QUERY:
            return state.set('moduleQuery', action.query);
        case types.UPDATE_MODULE_ITEM_QUERY:
            return state.set('moduleItemQuery', action.query);
        case types.UPDATE_ACTIVE_ITEM_FILTER:
            return state.setIn(['filters', 'active'], action.active);
        case types.UPDATE_ITEM_STOCK_STATUS_FILTER:
            return state.setIn(['filters', 'stockStatus'], action.stockStatus);
        case types.SHOW_MODULES_ARTICLES:
            return state.merge(fromJS({
                selectedModule: action.moduleName,
                showArticles: true,
                showStores: false,
                moduleItems: [],
                associatedStores: []
            }));
        case types.SHOW_MODULES_STORES:
            return state.merge(fromJS({
                selectedModule: action.moduleName,
                showArticles: false,
                showStores: true,
                moduleItems: [],
                associatedStores: []
            }));
        default:
            return state
    }
};

export const initialise = () => {
    return (dispatch) => {
        dispatch(fetchModules());
    }
};

export const fetchModules = () => {
    return function (dispatch, getState) {
        const {moduleQuery} = getState().module.toJS();

        const path = __API__ + `/api/ui/module?search=${moduleQuery}`;

        return axios.get(path)
            .then(response => {
                return response.data;
            })
            .then(modules => {
                dispatch(fetchModulesSuccess(modules));
            })
            .catch(error => {
                console.log(error)
                // dispatch(errorHandler(error.response))
            });
    }
};

export const fetchModulesSuccess = (modules) => {
    return {
        type: types.FETCH_MODULES_SUCCESS,
        modules: modules
    };
};

export const fetchStores = () => {
    return function (dispatch) {
        let path = __API__ + '/api/ui/store';

        return axios.get(path)
            .then(response => {
                return response.data;
            })
            .then(stores => {
                dispatch(fetchStoresSuccess(stores));
            })
            .catch(error => {
                console.log(error)
                // dispatch(errorHandler(error.response))
            });
    }
};

export const fetchStoresSuccess = (stores) => {
    return {
        type: types.FETCH_STORES_SUCCESS,
        stores: stores
    };
};

export const fetchModuleItems = (moduleName) => {
    return function (dispatch) {
        const path = __API__ + `/api/ui/module/${moduleName}/item`;

        return axios.get(path)
            .then(response => {
                return response.data;
            })
            .then(moduleItems => {
                dispatch(fetchModuleItemsSuccess(moduleItems));
            })
            .catch(error => {
                console.log(error);
                dispatch(fetchModuleItemsSuccess([]));
            });
    }
};

export const fetchModuleItemsSuccess = (moduleItems) => {
    return {
        type: types.FETCH_MODULE_ITEMS_SUCCESS,
        moduleItems: moduleItems
    };
};

export const fetchModulesStores = (moduleName) => {
    return function (dispatch) {
        const path = __API__ + `/api/ui/module/${moduleName}/store`;

        return axios.get(path)
            .then(response => {
                return response.data;
            })
            .then(stores => {
                dispatch(fetchModulesStoresSuccess(stores));
            })
            .catch(error => {
                console.log(error);
                dispatch(fetchModulesStoresSuccess([]));
            });
    }
};

export const fetchModulesStoresSuccess = (stores) => {
    return {
        type: types.FETCH_MODULE_STORES_SUCCESS,
        stores: stores
    };
};

export const updateModuleQuery = (query) => {
    return function (dispatch) {
        dispatch({
            type: types.UPDATE_MODULE_QUERY,
            query: query
        });
        dispatch(fetchModules());
    }
};

export const showModulesArticles = (moduleName) => {

    return (dispatch) => {
        dispatch({
            type: types.SHOW_MODULES_ARTICLES,
            moduleName: moduleName
        });
        dispatch(fetchModuleItems(moduleName));
    }
};

export const showModulesStores = (moduleName) => {

    return (dispatch) => {
        dispatch({
            type: types.SHOW_MODULES_STORES,
            moduleName: moduleName
        });
        dispatch(fetchModulesStores(moduleName));
    }
};

export const updateModuleItemQuery = (query) => {
    return {
        type: types.UPDATE_MODULE_ITEM_QUERY,
        query: query
    };
};

export const updateActiveItemFilter = (active) => {
    return {
        type: types.UPDATE_ACTIVE_ITEM_FILTER,
        active: active
    };
};

export const updateItemStockStatusFilter = (stockStatus) => {
    return {
        type: types.UPDATE_ITEM_STOCK_STATUS_FILTER,
        stockStatus: stockStatus
    };
};

export const createModule = (module) => {
    return function (dispatch) {
        const path = __API__ + '/api/ui/module';

        const command = {
            name: module.name,
            start: module.start,
            end: module.end,
            contract: module.contract,
            assortment: module.assortment,
            unlimitedStock: module.unlimitedStock
        };

        return axios.post(path, command)
            .then(response => {
                return response.data;
            })
            .then(() => dispatch(fetchModules()))
            .catch(error => {
                console.log(error);
                dispatch(fetchModules());
            });
    }
};

export const updateModuleContract = (moduleName, contract) => {
    return function (dispatch) {
        const path = __API__ + `/api/ui/module/${moduleName}/contract`;

        const command = {
            contract: contract
        };

        return axios.put(path, command)
            .then(response => {
                return response.data;
            })
            .then(() => dispatch(fetchModules()))
            .catch(error => {
                console.log(error);
                dispatch(fetchModuleItemsSuccess([]));
            });
    }
};

export const updateModuleAssortment = (moduleName, assortment) => {
    return function (dispatch) {
        const path = __API__ + `/api/ui/module/${moduleName}/assortment`;

        const command = {
            moduleName: moduleName,
            assortment: assortment
        };

        return axios.put(path, command)
            .then(response => {
                return response.data;
            })
            .then(() => dispatch(fetchModules()))
            .then(() => {
                toast.success('Sortiment wurde geändert!');
            })
            .catch(error => {
                toast.error('Sortiment konnte nicht geändert werden!');
            });
    }
};



export const activateUnlimitedStock = (moduleName) => {
    return function (dispatch, getState) {
        const path = __API__ + `/api/ui/module/${moduleName}/unlimitedstock/activate`;

        const command = {
            moduleName: moduleName
        };

        return axios.put(path, command)
            .then(response => {
                return response.data;
            })
            .then(() => {
                dispatch(fetchModules());
            })
            .then(() => {
                toast.success('NOS wurde geändert!');
            })
            .catch(error => {
                toast.error('NOS konnte nicht geändert werden!');
            });
    }
};

export const deactivateUnlimitedStock = (moduleName) => {
    return function (dispatch, getState) {
        const path = __API__ + `/api/ui/module/${moduleName}/unlimitedstock/deactivate`;

        const command = {
            moduleName: moduleName
        };

        return axios.put(path, command)
            .then(response => {
                return response.data;
            })
            .then(() => {
                dispatch(fetchModules());

            })
            .then(() => {
                toast.success('NOS wurde geändert');
            })
            .catch(error => {
                toast.error('NOS konnte nicht geändert werden!');
            });
    }
};

export const updateModuleReplenishmentPeriod = (moduleName, start, end) => {
    return function (dispatch) {
        const path = __API__ + `/api/ui/module/${moduleName}/replenishmentperiod`;

        const command = {
            start: start,
            end: end
        };

        return axios.put(path, command)
            .then(response => {
                return response.data;
            })
            .then(() => dispatch(fetchModules()))
            .catch(error => {
                dispatch(fetchModuleItemsSuccess([]));
            });
    }
};

export const updateArticleGtin = (oldGtin, newGtin) => {
    return function (dispatch, getState) {
        const path = __API__ + `/api/ui/article/gtin`;

        const command = {
            oldGtin: oldGtin,
            newGtin: newGtin
        };

        return axios.put(path, command)
            .then(response => {
                return response.data;
            })
            .then(() => {
                const {selectedModule} = getState().module.toJS();
                dispatch(fetchModuleItems(selectedModule));
            })
            .catch(error => {
                dispatch(fetchModuleItemsSuccess([]));
            });
    }
};

export const updateArticleErpIdno = (gtin, erpIdno) => {
    return function (dispatch, getState) {
        const path = __API__ + `/api/ui/article/erpidno`;

        const command = {
            gtin: gtin,
            erpIdno: erpIdno
        };

        return axios.put(path, command)
            .then(response => {
                return response.data;
            })
            .then(() => {
                const {selectedModule} = getState().module.toJS();
                dispatch(fetchModuleItems(selectedModule));
                toast.success('ERP-IdNo wurde geändert!');
            })
            .catch(error => {
                const {selectedModule} = getState().module.toJS();
                dispatch(fetchModuleItems(selectedModule));
                toast.error('ERP-IdNo konnte nicht geändert werden!');
            });
    }
};

export const updateVendorArticleNumber = (gtin, vendorArticleNumber) => {
    return function (dispatch, getState) {
        const path = __API__ + '/api/ui/article/vendorarticlenumber';

        const command = {
            gtin: gtin,
            vendorArticleNumber: vendorArticleNumber
        };

        return axios.put(path, command)
        .then(response => {
            return response.data;
        })
        .then(() => {
            const {selectedModule} = getState().module.toJS();
            dispatch(fetchModuleItems(selectedModule));
            toast.success('Händler-Artikelnummer wurde geändert!');
        })
        .catch(error => {
            const {selectedModule} = getState().module.toJS();
            dispatch(fetchModuleItems(selectedModule));
            toast.error('Händler-Artikelnummer konnte nicht geändert werden!');
        });
    }
};

export const updateArticleName = (gtin, name) => {
    return function (dispatch, getState) {
        const path = __API__ + '/api/ui/article/name';

        const command = {
            gtin: gtin,
            name: name
        };

        return axios.put(path, command)
            .then(response => {
                return response.data;
            })
            .then(() => {
                const {selectedModule} = getState().module.toJS();
                dispatch(fetchModuleItems(selectedModule));
                toast.success('Artikelname wurde geändert!');
            })
            .catch(error => {
                const {selectedModule} = getState().module.toJS();
                dispatch(fetchModuleItems(selectedModule));
                toast.error('Artikelname konnte nicht geändert werden!');
            });
    }
};

export const deactivateModuleItem = (moduleName, gtin, deactivationReason) => {
    return function (dispatch, getState) {
        const path = __API__ + `/api/ui/module/${moduleName}/item/${gtin}/deactivate`;

        const command = {
            moduleName: moduleName,
            gtin: gtin,
            reason: deactivationReason
        };

        return axios.put(path, command)
            .then(response => {
                return response.data;
            })
            .then(() => {
                const {selectedModule} = getState().module.toJS();
                dispatch(fetchModuleItems(selectedModule));
            })
            .catch(error => {
                dispatch(fetchModuleItemsSuccess([]));
            });
    }
};

export const activateModuleItem = (moduleName, gtin) => {
    return function (dispatch, getState) {
        const path = __API__ + `/api/ui/module/${moduleName}/item/${gtin}/activate`;

        const command = {
            moduleName: moduleName,
            gtin: gtin
        };

        return axios.put(path, command)
            .then(response => {
                return response.data;
            })
            .then(() => {
                const {selectedModule} = getState().module.toJS();
                dispatch(fetchModuleItems(selectedModule));
            })
            .catch(error => {
                console.log(error);
                dispatch(fetchModuleItemsSuccess([]));
            });
    }
};

export const addStoreToModule = (storeGln, moduleName) => {
    return function (dispatch) {
        const path = __API__ + '/api/ui/areacontrol/addmoduletostore';

        const command = {
            storeGln: storeGln,
            moduleName: moduleName
        };

        return axios.post(path, command)
            .then(response => {
                return response.data;
            })
            .then(() => dispatch(fetchModulesStores(moduleName)))
            .catch(error => {
                console.log(error);
                dispatch(fetchModulesStores([]));
            });
    }
};

export const removeStoreFromModule = (storeGln, moduleName) => {
    return function (dispatch) {
        const path = __API__ + '/api/ui/areacontrol/removemodulefromstore';

        const command = {
            storeGln: storeGln,
            moduleName: moduleName
        };

        return axios.post(path, command)
            .then(response => {
                return response.data;
            })
            .then(() => dispatch(fetchModulesStores(moduleName)))
            .catch(error => {
                toast.error('Filiale konnte nicht aus Flächensteuerung entfernt werden.');
            });
    }
};

export const deleteModule = (moduleName) => {
    return function (dispatch) {
        const path = __API__ + `/api/ui/module/${moduleName}`;

        const command = {
            moduleName: moduleName
        };

        return axios.delete(path, command)
            .then(response => {
                return response.data;
            })
            .then(() => {
                dispatch(fetchModules());
                toast.success('Modul erfolgreich gelöscht!');
            })
            .catch(error => {
                console.log(error);
                dispatch(fetchModules()).then(() => {
                    toast.error('Modul konnte nicht gelöscht werden!');
                });
            });
    }
};

export const getModuleItems = (state) => {
    if (!state.has('moduleItems') || !state.has('moduleItemQuery')) {
        return List();
    }

    let filteredItems = state.get('moduleItems');

    const filters = state.get('filters');

    if (filters.has('active') && filters.get('active') !== '') {
        filteredItems = filteredItems.filter((item) => {
            return item.get('replenishmentActive') === filters.get('active');
        });
    }

    if (filters.has('stockStatus') && filters.get('stockStatus') !== '') {
        filteredItems = filteredItems.filter((item) => {
            const currentStock = item.getIn(['currentStock', 'stockQuantity']);
            if(filters.get('stockStatus') === 'IN_STOCK') {
                return currentStock > 0;
            }
            if(filters.get('stockStatus') === 'NO_STOCK') {
                return currentStock === 0;
            }

            return true;
        });
    }

    if (!state.get('moduleItemQuery')) {
        return filteredItems;
    }

    const queryTokens = state.get('moduleItemQuery').split(' ');

    const searchProperties = [
        'module.name', 'article.gtin', 'article.name', 'article.erpIdno', 'article.vendorArticleNumber'
    ];

    return filteredItems.filter((moduleItem) => {
        return queryTokens.every((token) => {
            return searchProperties.some((propertyPath) => {
                let path = propertyPath.split('.');
                return moduleItem.getIn(path).toLowerCase().indexOf(token.toLowerCase()) > -1;
            });
        });
    })
};

export const getSelectedModule = (state) => {
    if (!state.get('selectedModule')) {
        return null;
    }

    return state.get('modules').find((module) => module.get('name') === state.get('selectedModule'));
};




// WEBPACK FOOTER //
// ./src/admin/module/overview/reducer.js